(function(angular){
	'use strict';
	
	angular
		.module('campaignsModule')
		.controller('IncomeLandingController', [
			'globalConfig',
			'ReitElementFactory',
			IncomeLandingFunction
		]);
	
	function IncomeLandingFunction(
		globalConfig,
		ReitElementFactory
	){
		var campaigns = this;

		campaigns.$onInit = function() {
			angular.extend(campaigns, globalConfig);
			
			ReitElementFactory
				.getReitElementsForRiaPlan(campaigns.incomePlanId, ['flatReitElementList'])
				.then(function(formattedLists) {
					campaigns.featuredProperties = formattedLists.flatReitElementList;
				});
		};
	}
})(window.angular);